import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeesEmployeeCompetencyReviewsMutateResponseType,
  ApiManagersEmployeesEmployeeCompetencyReviewsMutateRequestType,
} from "~/domains";

type RequestDataType = {
  employeeId: string;
  body: ApiManagersEmployeesEmployeeCompetencyReviewsMutateRequestType;
};

const request = ({ employeeId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersEmployeesEmployeeCompetencyReviewsMutateResponseType>(
      `/api/managers/employees/${employeeId}/employee_competency_reviews`,
      {
        employeeCompetencyReview: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersEmployeesEmployeeCompetencyReviewsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersEmployeesEmployeeCompetencyReviewsMutateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
